module.exports = __webpack_public_path__ + "a1afc006a57fb48f0c43db58cc0825d1.svg";